import { useQuery } from "react-query";
import endpoints from "./EndPoints"
import { getAlarmWays } from "./Services";




export const useGetAlarmWays = () => {
  return useQuery([endpoints.getAlarmWaysList], () => getAlarmWays(), {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};


